'use client';

import React from 'react';
import { StyledCtaBanner } from './CanonicalUrlCheckerTool.styles';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Build canonical pages worth ranking</h2>
        <p>
          CommonNinja has 226+ free widgets: accordions, tabs, comparison tables, feeds, and more.
          Consolidate content onto stronger canonical pages without writing a line of code.
        </p>
        <a className="banner-cta" href="/widgets">Browse all free widgets →</a>
      </div>
    </StyledCtaBanner>
  );
};
